import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { LayoutBackground} from '../../components/Layout/LayoutBackground/LayoutBackground.component';
import { Prompt } from '../../components/Prompt/Prompt.component';
import { EditUserPassword } from '../../components/UserProfile/EditUserPassword';
import { useLayoutContext } from '../../Context/Layout.context';
import { silentRenewal } from '../../services/users/identity/user.service';
import useSessionUser from '../../hooks/useSessionUser';
import { Paths } from '../../utils/routerUrls';
import { useTranslation } from 'react-i18next';

export const PasswordExpired: React.FC = () => {
  const history = useHistory();
  const [isPasswordExpiredPromptVisible, setIsPasswordExpiredPromptVisible] = useState<boolean>(true);
  const [isOpenAddNewPassword, setIsOpenAddNewPassword] = useState<boolean>(false);
  const [userEmail, setUserEmail] = useState<string | undefined>();

  const { user } = useSessionUser();

  const { setIsLoader } = useLayoutContext();
  const { t } = useTranslation();

  const handleOpenAddNewPassword = () => {
    if (!user) {
      throw new Error('empty user profile!');
    }

    setUserEmail(user.profile.preferred_username);
    setIsPasswordExpiredPromptVisible(false);
    setIsOpenAddNewPassword(true);
  };

  useEffect(() => {
    setIsLoader(true);
  }, []);

  useEffect(() => {
    setIsLoader(false);
  }, [user]);

  useEffect(() => {
    silentRenewal();
  }, []);

  return (
    <>
      <LayoutBackground />
      {user && (
        <>
          <Prompt
            type="warning"
            open={isPasswordExpiredPromptVisible}
            isBold={true}
            size="xs"
            mainText={'Prosimy o zmianę hasła. Wygasł termin ważności Twojego dotychczasowego hasła.'}
            mainActionButtonText={`Ustaw nowe hasło w ${t('global:shortNames.system')}`}
            onConfirm={handleOpenAddNewPassword}
            isRemovedBackdrop={true}
          />
          {isOpenAddNewPassword && (
            <EditUserPassword
              open={true}
              userEmail={userEmail}
              onNavBack={() => history.push('/')}
              navButtonLabel="Powrót do logowania"
              title={`Ustaw nowe hasło w ${t('global:shortNames.system')}`}
            />
          )}
        </>
      )}
    </>
  );
};
